import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// A custom index for this app
const theme = createTheme({
  spacing: 4,
  palette: {
    primary: {
      main: "#556cd6",
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    fontSize: 14,
    hero: {
      fontSize: 24,
      fontWeight: "600 !important",
      lineHeight: "24px",
    },
    title1: {
      fontSize: 20,
      fontWeight: "500 !important",
      lineHeight: "24px",
    },
    title2: {
      fontSize: 18,
      fontWeight: "500 !important",
      lineHeight: "24px",
    },
    title3: {
      fontSize: 16,
      fontWeight: "500 !important",
      lineHeight: "24px",
    },
    body: {
      fontSize: 16,
      lineHeight: "24px",
    },
    small: {
      fontSize: 14,
      lineHeight: "24px",
    },
    mini: {
      fontSize: 12,
      lineHeight: "24px",
    },
  },
});

export default theme;
